<template>
  <section style="display:inline">
    <el-select clearable :size="Tsize?Tsize:'small'" v-model="aNow" placeholder="大类">
      <el-option v-for="item in aArr" :key="item.id" :label="'('+item.code+') '+item.name" :value="item.id">
      </el-option>
    </el-select>
    <el-select clearable :size="Tsize?Tsize:'small'" v-model="bNow" placeholder="二级分类">
      <el-option v-for="item in bArr" :key="item.id" :label="'('+item.code+') '+item.name" :value="item.id">
      </el-option>
    </el-select>
    <el-select clearable :size="Tsize?Tsize:'small'" v-model="cNow" placeholder="三级分类">
      <el-option v-for="item in cArr" :key="item.id" :label="'('+item.code+') '+item.name" :value="item.id">
      </el-option>
    </el-select>
    <el-select clearable :size="Tsize?Tsize:'small'" v-model="dNow" placeholder="四级分类">
      <el-option v-for="item in dArr" :key="item.id" :label="'('+item.code+') '+item.name" :value="item.id">
      </el-option>
    </el-select>
  </section>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    props: ['a', 'b', 'c', 'd', 'Tsize'],
    data() {
      return {
        aArr: [],
        bArr: [],
        cArr: [],
        dArr: [],

        aNow: "",
        bNow: "",
        cNow: "",
        dNow: "",

      }
    },
    mounted() {
      // 获取省份
      this.getType('', 'a')

      console.log(this.a)
      this.aNow = this.a
      this.bNow = this.b
      this.cNow = this.c
      this.dNow = this.d
    },
    methods: {
      resetType() {
        this.aNow = ''
        this.bNow = ''
        this.cNow = ''
        this.dNow = ''
      },
      // 通过parentId获取省市区
      getType(parentId, type, formType) {
        ajax.get('/asset/classify/child/list', {
          parentId,
        }, (res) => {
          switch (type) {
            case "a":
              this.aArr = res.vo.array
              break;
            case "b":
              this.bArr = res.vo.array
              break;
            case "c":
              this.cArr = res.vo.array
              break;
            case "d":
              this.dArr = res.vo.array
              break;
          }
        })
      },
      getAddress() {
        if (this.dNow) {
          return this.dNow
        } else if (this.cNow) {
          return this.cNow
        } else if (this.bNow) {
          return this.bNow
        } else if (this.aNow) {
          return this.aNow
        }
      },
    },
    watch: {
      'a'() {
        this.aNow = this.a
      },
      'b'() {
        this.bNow = this.b
      },
      'c'() {
        this.cNow = this.c
      },
      'd'() {
        this.dNow = this.d
      },
      'aNow'() {
        this.getType(this.aNow, "b")
      },
      'bNow'() {
        this.getType(this.bNow, "c")
      },
      'cNow'() {
        this.getType(this.cNow, "d")
      },
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/page/asset/components/type.vue